import { useState } from 'react'

import { TablePagination } from '@/components/ui/pagination'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { Demo, DsSection } from '../primitives'

const PAGE_SIZE = 3
const ROWS = ['Acme Logistics', 'Beta Freight', 'Cascade Carriers', 'Delta Haulage', 'Eastbound Express']

export function PaginationSection() {
  const [page, setPage] = useState(1)
  const start = (page - 1) * PAGE_SIZE
  const rows = ROWS.slice(start, start + PAGE_SIZE)

  return (
    <DsSection id="pagination" title="Table pagination">
      <Demo
        label="Below a paginated table — `hasNextPage` / `hasPreviousPage` come straight from the API's `next` / `previous`"
        className="flex flex-col gap-4"
      >
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="font-semibold">Name</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((name) => (
              <TableRow key={name}>
                <TableCell className="font-medium">{name}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          page={page}
          count={ROWS.length}
          hasNextPage={start + PAGE_SIZE < ROWS.length}
          hasPreviousPage={page > 1}
          onPageChange={setPage}
          itemLabel="certificate holder"
        />
      </Demo>

      <Demo label="Everything fits on one page — renders nothing, so it is safe to drop below any table">
        <TablePagination
          page={1}
          count={2}
          hasNextPage={false}
          hasPreviousPage={false}
          onPageChange={() => {}}
        />
      </Demo>
    </DsSection>
  )
}
